import React, { ReactElement } from "react";
import { Tooltip as MaterialTooltip } from "@material-ui/core";

interface Props {
  children: ReactElement<any, any>;
  title: string | null;
}

export default function Tooltip({ children, title }: Props) {
  return (
    <MaterialTooltip title=""  disableFocusListener disableTouchListener>{children}</MaterialTooltip>
  );
}
